module.exports = __webpack_public_path__ + "img/video-a3.9be13387.jpg";